<div class="table-responsive">
  <table class="table table-striped table-hover mb-0">
    <thead class="table-light">
      <tr>
        <th>#</th>
        <th>Vacuna</th>
        <th>Fecha</th>
        <th>Lote</th>
        <th>Prestador</th>
        <th>Fabricante</th>
        <th>Estado</th>
      </tr>
    </thead>
    <tbody>
      @for (imm of immunizations(); track $index) {
        <tr>
          <td>{{ $index + 1 }}</td>
          <td>{{ imm.vacuna || '—' }}</td>
          <td>{{ formatDate(imm.fecha) || '—' }}</td>
          <td>
            <code>{{ imm.lote || '—' }}</code>
          </td>
          <td>{{ imm.prestador || '—' }}</td>
          <td>{{ imm.fabricante || '—' }}</td>
          <td>
            @let badge = getEstadoBadge(imm.estado);
            <span class="badge {{ badge.color }}">{{ badge.label }}</span>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
